<script setup lang="ts">
import { useProductStore } from '~/store/product/productStore';

const productStore = useProductStore();
const {
  offer,
  getDeliveryPrice,
  getDeliveryInfo,
  product
} = storeToRefs(productStore)
</script>

<template>
  <div class="product-page__info-bullets">
    <div class="df sm-fdc">
      <div class="fb50">
        <div class="weight--interbold mb-h">{{ $t('www.product.delivery.title') }}</div>
        <div>
          <div>
            <span class="capitalize-first-letter lowercase-text">{{ offer.details.bestShipping.estimationDates }}</span>
          </div>
          <div>
            {{ getDeliveryInfo }}
          </div>
          <div>
            {{ getDeliveryPrice }}
          </div>
        </div>

        <div class="pt-1" v-html="$t('www.product.delivery.shippingFrom', {'shippingFrom' : offer.details.shippingFrom})"/>
      </div>
      <div class="ml-3 fb50 sm-ml-0 sm-pt-2">
        <div class="weight--interbold mb-h" v-html="$t('www.product.delivery.return.title')"/>
        <div v-if="offer.details.returnItem">{{ offer.details.returnItem.message }}</div>
        <div v-else v-html="$t('www.product.delivery.return.law.days', {'returnPeriod': offer.details.returnPeriod})"/>
        <div v-if="offer.details.returnCountry" class="pt-1" v-html="$t('www.product.return_country', {'returnCountry': offer.details.returnCountry})"/>
        <div v-if="offer.details.freeReturn" class="pt-1" v-html="$t('www.product.return_is_free')"/>
        <div v-else class="pt-1" v-html="$t('www.product.return_is_not_free')"/>
      </div>
    </div>
    <div class="pt-1">
      <p class="weight--interbold">{{ $t('www.product.delivery.more_info.title') }}</p>
      <p>
        <a
            class="underline-text"
            :href="$t('www.product.delivery.order.link.value')"
            data-tclz-selector="order-delivery-information"
            :data-tclz-label="product.categoryPath"
            data-tclz-category="product"
            data-tclz-action="click on order and delivery information"
            target="_blank">
        {{ $t('www.product.delivery.order.link.0') }}</a>
      </p>
      <p>
        <a
            class="underline-text"
            :href="$t('www.product.delivery.return.link.value')"
            target="_blank"
            data-tclz-selector="return-refunds-information"
            :data-tclz-label="product.categoryPath"
            data-tclz-category="product"
            data-tclz-action="returns and refunds information">
        {{ $t('www.product.delivery.return.link.0') }}</a>
      </p>
    </div>
  </div>
</template>
